import { HeatMapChart } from '@/components/composite/Charts/HeatMapChart';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';
import { percentFormat } from '@/hooks/format/useFormatNumber';

export const bestTimeToPostConfig = {
    minWidth: 750,
    name: {
        day: {
            engagement_rate: 'chart.best_time_to_post.engagement_more',
            video_views: 'chart.best_time_to_post.video_views_more',
            reach: 'chart.best_time_to_post.reach_more'
        },
        value: {
            engagement_rate: 'chart.best_time_to_post.engagement_less',
            video_views: 'chart.best_time_to_post.video_views_less',
            reach: 'chart.best_time_to_post.reach_less'
        }
    },
    noTableView: true,
    csv: true,
    id: 'best_time_to_post',
    color: {
        value: 'white'
    },
    colors: {
        light: {
            blue200: '#96D8FF',
            blue300: '#33a1ff',
            blue400: '#1a95ff',
            blue: '#0089ff'
        },
        dark: {
            blue200: '#11263F',
            blue300: '#0E3861',
            blue400: '#085BA5',
            blue: '#0089ff'
        }
    },
    legendType: 'bttp',
    tooltipTranslation: {
        filtersToken: {
            engagement_rate: 'chart.tiktok.best_time_to_post_engagement_tooltip_chart',
            video_views: 'chart.tiktok.best_time_to_post_views_tooltip_chart',
            likes: 'chart.tiktok.best_time_to_post_likes_tooltip_chart'
        },
        values: ['date', 'day', 'value', 'count_posts']
    },
    valueFormat: {
        engagement_rate: { ...percentFormat, maximumFractionDigits: 5 },
        likes: {},
        video_views: {}
    },
    legendHighlightValueTranslation: {
        filtersToken: {
            engagement_rate: 'chart.tiktok.best_time_to_post_engagement_legend_highlight',
            video_views: 'chart.tiktok.best_time_to_post_views_legend_highlight',
            likes: 'chart.tiktok.best_time_to_post_likes_legend_highlight'
        },
        values: ['date', 'day']
    },
    tooltip: 'chart.tiktok.tooltip_best_time_to_post_views',
    size: SIZE_FULL,
    type: 'chart',
    iconHighestValue: 'star',
    margin: { bottom: 10, left: -30 },
    breakpoints: [
        { color: 'blue200', r: 3.5 },
        { color: 'blue300', r: 7.5 },
        { color: 'blue400', r: 12.5 },
        { color: 'blue', r: 12.5 }
    ],
    defaultFilter: 'video_views',
    filters: {
        video_views: {
            title: 'chart.tiktok.best_time_to_post_views',
            menu: 'chart.tiktok.best_time_to_post_filter_views'
        },
        likes: {
            title: 'chart.tiktok.best_time_to_post_likes',
            menu: 'chart.tiktok.best_time_to_post_filter_likes'
        },
        engagement_rate: {
            title: 'chart.tiktok.best_time_to_post_engagement',
            menu: 'chart.tiktok.best_time_to_post_filter_engagement'
        }
    },
    element: HeatMapChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
